module.exports = __webpack_public_path__ + "images/category_lp/alcohol/assessment_achievements/2_c858567e4b02eee7f99b82d515b47f9d.jpg";